__turbopack_context__.v({
  "className": "nunito_7fd9ea60-module__0zVxuG__className",
  "variable": "nunito_7fd9ea60-module__0zVxuG__variable",
});
